<template>
  <div v-if="personData" class="mt-6 p-lg-6 p-3">
    <h3 class="text-secondary font-weight-light text-center">Waiting for email confirmation</h3>
    <p>Please, check your inbox for confirmation email sent to: <b>{{personData.email}}</b></p>
    <div class="row justify-content-center align-items-center">
      <div class="mr-2">
        <button @click="refreshEmailConfirmation" class="btn btn-sm btn-light"><i class="fe fe-refresh-ccw mr-2"></i>Refresh status</button>
      </div>
      <div v-if="showResendButton">
        <span class="text-secondary font-weight-lighter ml-2 mr-2">or</span>
        <span @click="resendConfirmationMail" class="text-primary font-weight-lighter ml-1" type="button">Resend confirmation email</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { AuthStepsMixin } from '../mixins/AuthStepsMixin';
  import { resendConfirmationMailMixin } from '../../../mixins/resendConfirmationMailMixin';

  export default {
    name: 'EmailConfirmationStep',
    mixins: [AuthStepsMixin, resendConfirmationMailMixin],
    methods: {
      refreshEmailConfirmation: async function () {
        await this.$store.dispatch('fetchAccount');
        if (this.$store.state.account.status !== 'inactive') {
          window.location.href = '/';
        }
      },
    },
  };
</script>

<style scoped>

</style>
